module.exports = __webpack_public_path__ + "assets/49c97aa30b50294047ff02c1dceb0615.svg";